import { RegisterForm } from 'components';

export const Register = () => {
  return <RegisterForm />;
};
